import React from 'react'
import PropTypes, { oneOfType } from 'prop-types'
import * as Component from './ZeroResults.styles'
import { useSelector } from 'react-redux'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { getReplacedString, countActiveFilters } from 'settings/app/helpers'
import { entryPointId } from 'settings/app/constants'

/**
 * zero result hint component
 * @param radii
 * @param infoText
 * @param radius
 * @param onIncreaseRadiusClicked
 * @param onResetFiltersClicked
 * @returns {JSX.Element}
 * @constructor
 */
const ZeroResults = ({
  radii,
  infoText,
  radius,
  onIncreaseRadiusClicked,
  onResetFiltersClicked,
}) => {
  const [increaseTo, setIncreaseTo] = React.useState(null)
  const { application } = useSelector((state) => state)
  const { filter } = useSelector((state) => state)
  const { entryPoint } = application
  const textContext = React.useContext(TextContext)

  React.useEffect(() => {
    const indexOfRadius = radii.indexOf(radius)
    if (indexOfRadius >= 0 && indexOfRadius < radii.length - 1) {
      setIncreaseTo(radii[indexOfRadius + 1])
    } else {
      setIncreaseTo(0)
    }
  }, [radii, radius, increaseTo])

  return (
    <Component.Root
      id='zeroResult'
      className='container-content'
      data-cy='zero-result'>
      <Component.SearchIcon className='icon-f-magnifier' />
      <Component.InfoText>
        {infoText}
        {entryPoint === entryPointId.CROSS && (
          <>
            <br /> {textContext['zeroResults.text.hint']}
          </>
        )}
      </Component.InfoText>

      {radius !== 0 && radius !== '' && (
        <Component.LinkButton
          id='radiusButton'
          data-cy='increase-radius'
          onClick={ () => onIncreaseRadiusClicked(increaseTo) }
          text={ getReplacedString({
            search: textContext['zeroResults.option'],
            replaceWith:
              increaseTo !== 0
                ? `${ increaseTo / 1000 } km`
                : textContext['zeroResults.federalWide'],
          }) }
        />
      )}
      {onResetFiltersClicked &&
        filter?.collection?.length > 0 &&
        countActiveFilters(filter.collection) > 0 && (
          <Component.LinkButton
            id='filterResetButton'
            onClick={ onResetFiltersClicked }
            text={ textContext['zeroResults.filter.resetBtn'] }
            data-cy='reset-filters'
          />
        )}
    </Component.Root>
  )
}

ZeroResults.defaultProps = {
  onIncreaseRadiusClicked: false,
  onResetFiltersClicked: false,
}

ZeroResults.propTypes = {
  /** Array of possible radii */
  radii: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /** The info text */
  infoText: PropTypes.string.isRequired,
  /** The actual search radius */
  radius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Fired when increase to clicked
   * Signature: function(newRadius: string|number) {...}
   */
  onIncreaseRadiusClicked: oneOfType([PropTypes.bool, PropTypes.func]),
  /** Fired when reset filter clicked */
  onResetFiltersClicked: oneOfType([PropTypes.bool, PropTypes.func]),
}

export default ZeroResults
